import React from 'react';
import styled from 'react-emotion';
import PropTypes from 'prop-types';
import CoachInfos from '../CoachInfos';

const Container = styled.div`
  height: 140px;
  display: flex;
  flex-direction: row;
  margin-bottom: 12px;
`;

const ImageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  height: 140px;
  width: 140px;
`;

const Image = styled.img`
  height: 140px;
  width: 140px;
  margin-right: 7px;
  background-image: ${props => (props.url ? `url(${props.url})` : 'url(http://fakeimg.pl/140x140/)')};
  background-size: cover;
  background-position: center;
`;

const CoachListItem = ({ coach, imgSrc, onClick }) => (
  <Container onClick={onClick(coach)}>
    <ImageContainer>
      <Image url={imgSrc || 'http://fakeimg.pl/200x200/'} />
    </ImageContainer>
    <CoachInfos coach={coach} />
  </Container>
);

CoachListItem.propTypes = {
  coach: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    surname: PropTypes.string.isRequired,
    activityIds: PropTypes.arrayOf(PropTypes.string).isRequired
  }).isRequired,
  imgSrc: PropTypes.string,
  onClick: PropTypes.func.isRequired
};

CoachListItem.defaultProps = {
  imgSrc: null
};

export default CoachListItem;



// WEBPACK FOOTER //
// ./src/components/CoachListItem/CoachListItem.jsx